import React from 'react';
import { writerFacingRoomName } from '../../utils/roomChat';
import './Bookmarks.css';

const CATEGORIES = [
  { value: 'character', label: 'Characters', color: '#3B82F6' },
  { value: 'plot', label: 'Plot', color: '#10B981' },
  { value: 'setting', label: 'Setting', color: '#8B5CF6' },
  { value: 'theme', label: 'Themes', color: '#F59E0B' }
];

function BookmarkItem({ bookmark, onDelete, onCategoryChange }) {
  const getTypeIcon = () => {
    return bookmark.bookmark_type === 'synthesis' ? '\u{1F4DD}' : '\u{1F4AC}';
  };

  const getCategoryConfig = (categoryValue) => {
    return CATEGORIES.find(c => c.value === categoryValue);
  };

  const truncateContent = (content, maxLength = 200) => {
    if (!content || content.length <= maxLength) return content;
    return content.substring(0, maxLength) + '...';
  };

  const categoryConfig = getCategoryConfig(bookmark.category);
  const roomLabel = writerFacingRoomName(bookmark.session_name, bookmark.room_key, bookmark.session_type);

  return (
    <div className="bookmark-item">
      <div className="bookmark-item-header">
        <div className="bookmark-item-type">
          <span className="bookmark-type-icon">{getTypeIcon()}</span>
          <span className="bookmark-type-label">
            {bookmark.bookmark_type === 'synthesis' ? 'Synthesis' : 'Saved Message'}
          </span>
        </div>
        <button
          className="bookmark-delete-btn"
          onClick={() => onDelete(bookmark.id)}
          aria-label="Delete bookmark"
          title="Delete bookmark"
        >
          &times;
        </button>
      </div>

      <h3 className="bookmark-title">{bookmark.user_title}</h3>

      <div className="bookmark-content">
        {truncateContent(bookmark.content)}
      </div>

      <div className="bookmark-footer">
        <div className="bookmark-category">
          <label htmlFor={`category-${bookmark.id}`}>Category:</label>
          <select
            id={`category-${bookmark.id}`}
            value={bookmark.category || ''}
            onChange={(e) => onCategoryChange(bookmark.id, e.target.value || null)}
            className="category-select"
          >
            <option value="">None</option>
            {CATEGORIES.map(cat => (
              <option key={cat.value} value={cat.value}>
                {cat.label}
              </option>
            ))}
          </select>
        </div>

        {categoryConfig && (
          <span
            className="category-badge"
            style={{ backgroundColor: categoryConfig.color }}
          >
            {categoryConfig.label}
          </span>
        )}
      </div>

      {roomLabel && (
        <div className="bookmark-meta">Session: {roomLabel}</div>
      )}
      {bookmark.created_at && (
        <div className="bookmark-meta">
          Created: {new Date(bookmark.created_at).toLocaleDateString()}
        </div>
      )}
    </div>
  );
}

export default BookmarkItem;
